export default {
  RegioesAdministrativas: axios.create({
    baseURL: process.env.ENDPOINT_API + "regioes-administrativas"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/RegioesAdministrativas.js
// module id = xcdb
// module chunks = 32